import { PortfolioSlider } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/portfolio_slider';
import { ClickEventPropsBase, reportClickBase } from './base';

interface ReportClickPortfolioSliderClickProps extends ClickEventPropsBase {
    additionalDataMessage: PortfolioSlider;
}

export const reportPortfolioSliderClick = ({
    additionalDataMessage,
    ...props
}: ReportClickPortfolioSliderClickProps) => {
    reportClickBase<PortfolioSlider>({
        ...props,
        additionalData: {
            type: PortfolioSlider,
            message: additionalDataMessage,
        },
    });
};
